module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/2-e37a3343df4ca67c01c8cf37f3949072.jpg";